import React, { createContext, useContext, useEffect, useState } from 'react';
import { usePlayerEventData, PlayerEvents, PlayerActions, PlayerControlData, } from '@alucio/video';
export const PresentationPlayerContext = createContext(null);
PresentationPlayerContext.displayName = 'PresentationPlayerContext';
const PresentationPlayerProvider = (props) => {
    const playerEventData = usePlayerEventData();
    const [currentPlayerState, setCurrentPlayerState] = useState();
    /**
     * playerEventData useEffect handler which watches for player status updates and
     * stores them as jumpToAnim PlayerControlData messages in currentPlayerState.
     * This can then be used in the virtual environment to support init of attendees
     * joining mid presentation.
     */
    const handlePlayerEvent = () => {
        if ((playerEventData === null || playerEventData === void 0 ? void 0 : playerEventData.event) === PlayerEvents.statusEvent) {
            const newParam = {
                step: playerEventData.param.step,
                slide: playerEventData.param.slide,
            };
            const updatedPlayerState = new PlayerControlData(PlayerActions.jumpToAnim, newParam);
            setCurrentPlayerState(updatedPlayerState);
        }
    };
    useEffect(handlePlayerEvent, [playerEventData]);
    const contextValue = {
        playerEventData,
        currentPlayerState,
        setCurrentPlayerState,
    };
    return (React.createElement(PresentationPlayerContext.Provider, { value: contextValue }, props.children));
};
PresentationPlayerProvider.displayName = 'PresentationPlayerProvider';
export function usePresentationPlayerContext() {
    const context = useContext(PresentationPlayerContext);
    if (!context) {
        throw new Error('usePresentationPlayer must be used within the PresentationPlayerProvider');
    }
    return context;
}
export default PresentationPlayerProvider;
//# sourceMappingURL=index.js.map